import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function OpeningHookSection() {
  return <section className="py-24 px-4 bg-navy-800 relative border-t border-gold/10" data-id="element-161">
      <div className="max-w-3xl mx-auto" data-id="element-162">
        <FadeIn data-id="element-163">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-cream mb-12 text-center leading-tight" data-id="element-164">
            Haz que tu bebé duerma{' '}
            <span className="text-gold" data-id="element-165">6+ horas seguidas</span> en 7 días
            sincronizando su descanso con el horario del Daycare.
          </h2>
        </FadeIn>

        <div className="space-y-8 text-lg md:text-xl text-muted leading-relaxed font-light" data-id="element-166">
          <FadeIn delay={0.2} data-id="element-167">
            <p data-id="element-168">
              <strong className="text-cream font-medium" data-id="element-169">
                Son las 3:14 AM.
              </strong>{' '}
              Estás de pie en la cocina, balanceándote de un lado a otro con un
              bebé que no deja de llorar, mientras calculas cuántas horas de
              sueño te quedan antes de tener que manejar hacia el trabajo. El
              agotamiento no es solo cansancio; es un peso que pone en riesgo tu
              rendimiento laboral, tu paciencia y tu salud mental.
            </p>
          </FadeIn>

          <FadeIn delay={0.4} data-id="element-170">
            <p data-id="element-171">
              Si vives en Estados Unidos, sabes que aquí el sistema no perdona.
              No tienes a la abuela cerca para ayudarte con el bebé mientras
              tomas una siesta, y no puedes permitirte llegar a la oficina con
              "cerebro de neblina" un día más. Necesitas una solución que
              funcione rápido y que sea realista para tu estilo de vida.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}